import React from 'react'
import PagamentoSucessoPage from '../Page/PagamentoSucessoPage'


function PagamentoSucessoOrder() {

  return(
    <PagamentoSucessoPage />
  )
}

export default PagamentoSucessoOrder;
